<template>
    <el-dialog
        :visible.sync="visible"
        :show-close="true"
        width="860px"
        top="5vh"
        custom-class="researcher_detail_dialog"
        append-to-body
        @closed="handleClosed"
    >
        <div v-if="researcher" class="researcher_detail">
            <div class="detail_header">
                <button class="detail_close" type="button" aria-label="Close" @click="visible = false">×</button>
                <div class="detail_avatar">
                    <img :src="researcher.img" :alt="researcher.authorName" />
                </div>
                <div class="detail_header_text">
                    <h2 class="detail_name">{{ researcher.detail.headerTitle }}</h2>
                    <p class="detail_subtitle">{{ researcher.detail.headerSubtitle }}</p>
                </div>
            </div>

            <div class="detail_body">
                <section v-if="researcher.detail.researchInterests && researcher.detail.researchInterests.length" class="detail_section">
                    <h3 class="section_title">Research Interests</h3>
                    <ul class="interest_list">
                        <li v-for="(item, index) in researcher.detail.researchInterests" :key="index">{{ item }}</li>
                    </ul>
                </section>

                <section v-if="researcher.detail.professionalProfile" class="detail_section">
                    <h3 class="section_title">Professional Profile</h3>
                    <p
                        v-for="(paragraph, index) in researcher.detail.professionalProfile"
                        :key="index"
                        class="section_paragraph"
                    >
                        {{ paragraph }}
                    </p>
                </section>

                <section v-if="researcher.detail.researchProjects && researcher.detail.researchProjects.length" class="detail_section">
                    <h3 class="section_title">Selected Research Projects</h3>
                    <div
                        v-for="(project, index) in researcher.detail.researchProjects"
                        :key="index"
                        class="project_item"
                    >
                        <div class="project_title">{{ project.title }}</div>
                        <div v-if="project.grant" class="project_meta">{{ project.grant }}</div>
                        <div v-if="project.role" class="project_meta">{{ project.role }}</div>
                    </div>
                </section>

                <section v-if="researcher.detail.publications && researcher.detail.publications.length" class="detail_section">
                    <h3 class="section_title">Selected Publications</h3>
                    <div
                        v-for="(group, groupIndex) in researcher.detail.publications"
                        :key="groupIndex"
                        class="publication_group"
                    >
                        <h4 v-if="group.group" class="publication_group_title">{{ group.group }}</h4>
                        <ol class="publication_list">
                            <li v-for="(item, index) in group.items" :key="index">{{ item }}</li>
                        </ol>
                    </div>
                </section>

                <section v-if="researcher.detail.academicService && researcher.detail.academicService.length" class="detail_section">
                    <h3 class="section_title">Academic Service</h3>
                    <div
                        v-for="(group, groupIndex) in researcher.detail.academicService"
                        :key="groupIndex"
                        class="service_group"
                    >
                        <h4 v-if="group.group" class="service_group_title">{{ group.group }}</h4>
                        <ul class="bullet_list">
                            <li v-for="(item, index) in group.items" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                </section>

                <section v-if="researcher.detail.honors && researcher.detail.honors.length" class="detail_section">
                    <h3 class="section_title">Selected Honors and Awards</h3>
                    <ul class="bullet_list">
                        <li v-for="(item, index) in researcher.detail.honors" :key="index">{{ item }}</li>
                    </ul>
                </section>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ResearcherDetailDialog',
    data() {
        return {
            visible: false,
            researcher: null
        }
    },
    methods: {
        open(researcher) {
            this.researcher = researcher
            this.visible = true
        },
        handleClosed() {
            this.researcher = null
        }
    }
}
</script>

<style lang="scss">
.researcher_detail_dialog {
    border-radius: 8px;
    overflow: hidden;

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0;
        max-height: 88vh;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.12) transparent;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.1);
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.18);
        }
    }
}

.researcher_detail {
    .detail_header {
        position: relative;
        display: flex;
        gap: 24px;
        align-items: center;
        padding: 28px 32px;
        background: #1da6b8;
        color: #fff;
    }

    .detail_close {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.18);
        color: #fff;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        transition: background 0.2s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    .detail_avatar {
        width: 120px;
        height: 120px;
        flex-shrink: 0;
        border-radius: 8px;
        overflow: hidden;
        border: 3px solid rgba(255, 255, 255, 0.85);
        background: #fff;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .detail_name {
        margin: 0 0 10px;
        font-size: 28px;
        font-weight: 700;
        line-height: 1.3;
    }

    .detail_subtitle {
        margin: 0;
        font-size: 15px;
        line-height: 1.6;
        opacity: 0.95;
    }

    .detail_body {
        padding: 28px 32px 36px;
        background: #fff;
    }

    .detail_section + .detail_section {
        margin-top: 28px;
        padding-top: 28px;
        border-top: 1px solid #eef0f4;
    }

    .section_title {
        margin: 0 0 16px;
        font-size: 22px;
        font-weight: 700;
        color: #1da6b8;
    }

    .section_paragraph {
        margin: 0 0 14px;
        font-size: 15px;
        line-height: 1.75;
        color: #4b5563;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .interest_list {
        margin: 0;
        padding-left: 22px;
        color: #4b5563;

        li {
            font-size: 15px;
            line-height: 1.7;
            margin-bottom: 6px;
        }
    }

    .project_item + .project_item {
        margin-top: 18px;
    }

    .project_title {
        font-size: 15px;
        font-weight: 700;
        color: #111827;
        line-height: 1.5;
    }

    .project_meta {
        margin-top: 4px;
        font-size: 14px;
        line-height: 1.6;
        color: #6b7280;
    }

    .publication_group + .publication_group {
        margin-top: 16px;
    }

    .publication_group_title,
    .service_group_title {
        margin: 0 0 10px;
        font-size: 16px;
        font-weight: 700;
        color: #111827;
    }

    .publication_list {
        margin: 0;
        padding-left: 22px;
        color: #4b5563;

        li {
            font-size: 14px;
            line-height: 1.7;
            margin-bottom: 10px;
        }
    }

    .service_group + .service_group {
        margin-top: 16px;
    }

    .bullet_list {
        margin: 0;
        padding-left: 22px;
        color: #4b5563;

        li {
            font-size: 15px;
            line-height: 1.7;
            margin-bottom: 8px;
        }
    }
}

@media (max-width: 768px) {
    .researcher_detail_dialog {
        width: calc(100% - 24px) !important;
        margin: 0 auto !important;
    }

    .researcher_detail {
        .detail_header {
            flex-direction: column;
            align-items: flex-start;
            padding: 24px 20px;
        }

        .detail_avatar {
            width: 96px;
            height: 96px;
        }

        .detail_name {
            font-size: 22px;
        }

        .detail_subtitle {
            font-size: 14px;
        }

        .detail_body {
            padding: 24px 20px 28px;
        }

        .section_title {
            font-size: 20px;
        }
    }
}
</style>
